import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccessDeniedComponent {
  email: string = '';

  @Input('row-data')
  set _rowData(rowData: string) {
    try {
      let data = safeJsonInput<any>(rowData, null, 'access-denied.parse1');
      if (data && data.email) {
        this.email = data.email;
      }
    } catch (e) {}
  }
}
